import React from "react";

export const Expand = () => (
  <svg width="22px" height="22px">
    <title>Arrow in circle Copy 15</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="OOA-1" transform="translate(-1259.000000, -2226.000000)">
        <g id="Group-3" transform="translate(330.000000, 2203.000000)">
          <g id="Arrow-in-circle" transform="translate(930.000000, 24.000000)">
            <g
              id="Group-13-Copy-2"
              transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
            >
              <circle
                id="Oval"
                stroke="#979797"
                fill="#FFFFFF"
                cx="10"
                cy="10"
                r="10"
              />
              <polygon
                id="+"
                fill="#929292"
                points="10.3386667 9.05466667 12.7266667 9.05466667 12.7266667 10.3386667 10.3386667 10.3386667 10.3386667 12.7266667 9.05466667 12.7266667 9.05466667 10.3386667 6.66666667 10.3386667 6.66666667 9.05466667 9.05466667 9.05466667 9.05466667 6.66666667 10.3386667 6.66666667"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Close = () => (
  <svg width="22px" height="22px">
    <title>Arrow in circle Copy 15</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="OOA-1.1"
        transform="translate(-1259.000000, -2226.000000)"
        stroke="#979797"
      >
        <g id="Group-3" transform="translate(330.000000, 2203.000000)">
          <g
            id="Arrow-in-circle-Copy-7"
            transform="translate(930.000000, 24.000000)"
          >
            <g
              id="Group-13-Copy-2"
              transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
            >
              <circle id="Oval" fill="#FFFFFF" cx="10" cy="10" r="10" />
              <rect
                id="Rectangle"
                fill="#D8D8D8"
                x="7.83333333"
                y="9.83333333"
                width="3.66666667"
                height="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Cross = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      fill="#1D1D1B"
      fill-rule="evenodd"
      d="M9.044 9.933L.192 18.786a.63.63 0 1 0 .89.89L10 10.756l8.919 8.92a.627.627 0 0 0 .89 0 .63.63 0 0 0 0-.89l-8.852-8.853 8.858-8.859a.63.63 0 1 0-.89-.89L10 9.11 1.075.184a.63.63 0 0 0-.89.89l8.86 8.86z"
      opacity=".5"
    />
  </svg>
);
